module.exports = __webpack_public_path__ + "images/accents/accent-people-training@2x-049dadea98559efcfae4f35321457a74.webp";